import OTHER, {
  GRecaptchaActionTypes,
  OPEN_ADD_ADDRESSMNGT_MODAL,
  RESET_DISABLE_2FA_FACE_AUTH,
  SET_COUNTRY_FROM_IP,
  SET_HOLDING_APIS_TIME,
  SET_SHOULD_CLEAR_OTP_VALUES,
  SHOW_CONVERT_BLOCKED_POPUP,
  SHOW_KYC_UPGRADE_STRIP,
  SHOW_OTP_SUCCESS_POPUP,
  TAB_INACTIVE,
  TAB_REACTIVE,
  TOGGLE_XMAS_OFFER_POPUP,
  TOGGLE_NRI_POPUP,
  TOGGLE_PHONE_VERIFICATION_MODAL,
  SOURCE_INCOME_SHOW_MODAL,
  SOURCE_INCOME_SET_SELECTED_OPERATOR,
  SOURCE_INCOME_SET_SELECTED_INCOME,
  SOURCE_INCOME_SET_OTHER_INCOME,
  SOURCE_INCOME_SET_AUTHORISED_PERSON_NAME,
  SOURCE_INCOME_SET_AUTHORISED_PERSON_RELATIONSHIP,
  SOURCE_INCOME_SET_AUTHORISED_PERSON_AGREEMENT,
  SOURCE_INCOME_SET_OTHER_RELATIONSHIP,
  SOURCE_INCOME_SET_CURRENT_STEP,
  SOURCE_INCOME_RESET_FORM,
} from 'actionTypes/other';
import { ACTIVATE_POLLING, DEACTIVATE_POLLING } from 'actionTypes/socket';
import { SOURCE_INCOME_OPERATOR, STEPS } from 'constants/incomeSource';
import createReducer from 'helpers/createReducer';
import { add, timeNow } from 'helpers/day';
import IOther from 'types/IOther';

const returnNextMonthDate = () => add(timeNow(), 1, 'M');

const sourceIncomeInitialState = {
  selectedOperator: SOURCE_INCOME_OPERATOR.PERSONAL_OPERATOR,
  selectedIncome: '',
  otherIncome: '',
  authorisedPersonName: '',
  authorisedPersonRelationship: null,
  authorisedPersonAgreement: false,
  currentStep: STEPS.ACCOUNT_HANDLER,
  otherRelation: '',
  showModal: true,
};

const initialState: IOther = {
  isPageInactive: false,
  inActiveTime: returnNextMonthDate(),
  isTabInactive: false,
  isAddressManagementPopupOpen: false,
  tabReactiveTime: '',
  tabInactiveTime: '',
  showKycUpgradeStrip: true,
  showConvertBlockedPopup: false,
  showOtpSuccessPopup: false,
  countryFromIp: '',
  showPhoneVerificationModal: false,
  disable2faFaceAuth: {
    requestedEmail: '',
    requestedPasswordBase64: '',
  },
  shouldClearOtpValues: false,
  pollingActivated: false,
  holdingApiPollingTimestamp: 0,
  isMonsoonPopUpOpen: false,

  /** Source Income modal state */
  sourceIncome: sourceIncomeInitialState,
  isXmasPopUpOpen: false,
  gRecaptcha: {
    initialised: false,
    hidden: true,
  },
  isNriNoticeModalOpen: false,
};

export default createReducer(initialState, {
  [TAB_REACTIVE]: (state, action) => ({
    ...state,
    isPageInactive: false,
    isTabInactive: false,
    tabReactiveTime: action.payload.reactiveTime,
  }),
  [TAB_INACTIVE]: (state, action) => ({
    ...state,
    isPageInactive: true,
    inActiveTime: timeNow(),
    isTabInactive: true,
    tabInactiveTime: action.payload.inactiveTime,
  }),
  [OPEN_ADD_ADDRESSMNGT_MODAL]: (state, action) => ({
    ...state,
    isAddressManagementPopupOpen: action.payload,
  }),
  [SHOW_KYC_UPGRADE_STRIP]: (state, action) => ({
    ...state,
    showKycUpgradeStrip: action.payload,
  }),
  [SHOW_CONVERT_BLOCKED_POPUP]: (state, action) => ({
    ...state,
    showConvertBlockedPopup: action.payload,
  }),
  [SHOW_OTP_SUCCESS_POPUP]: (state, action) => ({
    ...state,
    showOtpSuccessPopup: action.payload,
  }),
  [SET_COUNTRY_FROM_IP]: (state, action) => ({
    ...state,
    countryFromIp: action.payload,
  }),
  [TOGGLE_PHONE_VERIFICATION_MODAL]: (state, action) => ({
    ...state,
    showPhoneVerificationModal: action.payload,
  }),
  [OTHER.COUNTRY_FROM_IP.SUCCESS]: (state, action) => ({
    ...state,
    countryFromIp: action.result.result.country,
  }),
  [OTHER.TWO_FA_EMAIL_PASSWORD_VERIFY.SUCCESS]: (state, action) => {
    let encryptedPassword: string;

    try {
      encryptedPassword = btoa(action.payload.password);
    } catch (error) {
      encryptedPassword = '';
    }

    return {
      ...state,
      disable2faFaceAuth: {
        requestedEmail: action.payload.email,
        requestedPasswordBase64: encryptedPassword,
      },
    };
  },
  [RESET_DISABLE_2FA_FACE_AUTH]: state => ({
    ...state,
    disable2faFaceAuth: initialState.disable2faFaceAuth,
  }),
  [SET_SHOULD_CLEAR_OTP_VALUES]: (state, action) => ({
    ...state,
    shouldClearOtpValues: action.payload,
  }),
  [ACTIVATE_POLLING]: state => ({
    ...state,
    pollingActivated: true,
  }),
  [DEACTIVATE_POLLING]: state => ({
    ...state,
    pollingActivated: false,
  }),
  [SET_HOLDING_APIS_TIME]: state => ({
    ...state,
    holdingApiPollingTimestamp: Date.now(),
  }),

  [TOGGLE_XMAS_OFFER_POPUP]: (state, action) => ({
    ...state,
    isXmasPopUpOpen: action.payload.value,
  }),

  [GRecaptchaActionTypes.SHOW]: state => ({
    ...state,
    gRecaptcha: {
      ...state.gRecaptcha,
      initialised: true,
      hidden: false,
    },
  }),
  [GRecaptchaActionTypes.HIDE]: state => ({
    ...state,
    gRecaptcha: {
      ...state.gRecaptcha,
      hidden: true,
    },
  }),

  [SOURCE_INCOME_SHOW_MODAL]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, showModal: action.payload },
  }),
  [SOURCE_INCOME_SET_SELECTED_OPERATOR]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, selectedOperator: action.payload },
  }),
  [SOURCE_INCOME_SET_SELECTED_INCOME]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, selectedIncome: action.payload },
  }),
  [SOURCE_INCOME_SET_OTHER_INCOME]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, otherIncome: action.payload },
  }),
  [SOURCE_INCOME_SET_AUTHORISED_PERSON_NAME]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, authorisedPersonName: action.payload },
  }),
  [SOURCE_INCOME_SET_AUTHORISED_PERSON_RELATIONSHIP]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, authorisedPersonRelationship: action.payload },
  }),
  [SOURCE_INCOME_SET_AUTHORISED_PERSON_AGREEMENT]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, authorisedPersonAgreement: action.payload },
  }),
  [SOURCE_INCOME_SET_OTHER_RELATIONSHIP]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, otherRelation: action.payload },
  }),
  [SOURCE_INCOME_SET_CURRENT_STEP]: (state, action) => ({
    ...state,
    sourceIncome: { ...state.sourceIncome, currentStep: action.payload },
  }),
  [SOURCE_INCOME_RESET_FORM]: (state, action) => ({
    ...state,
    sourceIncome: {
      ...sourceIncomeInitialState,
      currentStep: action.payload.screen,
    },
  }),
  [TOGGLE_NRI_POPUP]: (state, action) => ({
    ...state,
    isNriNoticeModalOpen: action.payload.value,
  }),
});
